import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user !== false) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center px-6" data-testid="page-admin-login">
      <form onSubmit={submit} className="w-full max-w-md bg-white p-10 rounded-xl border border-border-warm shadow-[0_10px_40px_rgba(0,0,0,0.06)]">
        <div className="text-center mb-8">
          <p className="eyebrow mb-2">Family Legacy Films</p>
          <h1 className="font-serif text-3xl">Admin Sign In</h1>
        </div>
        <label className="text-sm text-warmgrey mb-1 block">Email</label>
        <input required type="email" className="input-field mb-4" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
        <label className="text-sm text-warmgrey mb-1 block">Password</label>
        <input required type="password" className="input-field mb-6" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
        <button disabled={loading} className="btn-primary w-full justify-center" data-testid="login-submit">{loading ? "Signing in..." : "Sign In"}</button>
      </form>
    </div>
  );
}
